import React, { useState } from 'react';
import axios from 'axios'; 
import './App.css';
import { makeStyles } from '@material-ui/core/styles';
import fire, { serverTimeStamp } from './fire';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import SearchIcon from '@material-ui/icons/Search';
import { ThemeProvider, Box, Chip, Card, CardContent, Paper, IconButton, InputBase, LinearProgress } from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core/styles';

//const host_url = 'http://localhost:8080'
const namebot01_url = 'https://namebot01-54gaj3vfrq-an.a.run.app'
const namebot02_url = 'https://namebot02-54gaj3vfrq-an.a.run.app'

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#fff',
    },
    secondary: {
      light: '#000',
      main: '#4d4d4d',
      dark: '#000',
      contrastText: '#fff',
    },
  },
});

const useStyles = makeStyles(theme => ({
  main: {
    alignContent:'center',
    padding: '10px',
  },  
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  card: {
    marginTop: '3vh',
    minWidth: 275,
    backgroundColor: '#FFE5CC'
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  }, 
  chip: {
    margin: theme.spacing(0.5),
    fontSize: '12pt',
  },  
  progress: {
    width: '100%',
    marginTop: '20px',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  }   
}));

let query_string = window.location.search;
const params = new URLSearchParams(query_string);
console.log(params.values().next().done);
//const userCheckedData = params.get('test').split(',');

function App() {
  const check_engnum = /^[0-9a-zA-Z ]+$/; // 문자
  const inputPlaceholder = '원하시는 영어 키워드를 하나 또는 두개 입력해주세요!'
  const errorPlaceholder = '알파벳으로 된 키워드 입력이 가능합니다.'
  const [placeholderText, setPlacehoderText] = useState(inputPlaceholder)  
  const [keywords, setKeyWords] = useState('');
  const [chipData, setChipData] = useState(params.values().next().done?[]:params.get('checked').split(',').map((data,i)=>{
    return {label:data, click:false}
  }));
  const [loading, setLoading] = useState(0);
  const [disabled, setDisabled] = useState(false);
  const classes = useStyles();
  const db = fire.firestore();


  //console.log(userCheckedData)
  const single_pattern = async (words) => {
    try {
      let res = await axios.post(namebot01_url + '/single/pattern', { 'data' : words });
      let {data} = res.data;
  
      let dictData = data.map((result, i) => {
        return {
          label : result,
          click : false
        };
      });      

      setChipData((prevData) => {
        let concatData = prevData.concat(dictData);
        concatData.sort((a,b)=>{
          if (a.label.length>b.label.length) return 1;
          if (b.label.length>a.label.length) return -1;
          return 0;
        })
        return concatData;
      })

      setLoading((prevLoading)=>{
        let newLoading = prevLoading + 40
        if(newLoading >= 100){
          setDisabled(false)
        }
        return newLoading
      })
      console.log(data);   
      return data;
    }
    catch(err){
      console.error(err.name);
      console.error(err.message);
      //throw new Error(err.message)
      return err;
    }
    
  }

  const single_rnn = async (words) => {  
    
    try {
      setLoading(prevLoading=>(prevLoading+10))
      let res = await axios.post(namebot01_url + '/single/rnn', { 'data' : words });
      let {data} = res.data;

      let dictData = data.map((result, i) => {
        return {
          label : result,
          click : false
        };
      });      
      
      setChipData((prevData) => {
        let concatData = prevData.concat(dictData);
        concatData.sort((a,b)=>{
          if (a.label.length>b.label.length) return 1;
          if (b.label.length>a.label.length) return -1;
          return 0;
        })
        return concatData;
      })

      setLoading((prevLoading)=>{
        let newLoading = prevLoading + 60
        if(newLoading >= 100){
          setDisabled(false);
        }
        return newLoading;
      })
      console.log(data); 

      return data;
    }
    catch(err){
      console.error(err.name);
      console.error(err.message);
      //throw new Error(err.message)
      return err;
    }    

  }

  const compound_pattern = async (words) => {        
    console.log('start compound pattern')
    try {
      
      setLoading(prevLoading=>(prevLoading+5))
      let res = await axios.post(namebot01_url + '/compound/pattern', { 'data' : words });
      let { data } = res.data;

      //if (data.length > 0 ){

        let dictData = data.map((result, i) => {
          return {
            label : result,
            click : false
          };
        });      
        
        setChipData((prevData) => {
          let concatData = prevData.concat(dictData);
          concatData.sort((a,b)=>{
            if (a.label.length>b.label.length) return 1;
            if (b.label.length>a.label.length) return -1;
            return 0;
          })
          return concatData;
        })
  

        setLoading((prevLoading)=>{
          let newLoading = prevLoading + 40;
          if(newLoading >= 100){
            setDisabled(false);
          }
          return newLoading;
        })
        console.log(data);
        return data;
      /*}
      else {

        let new_words = [words.join(' ')]
        console.log(new_words)
        const single = await single_pattern(new_words)
        return single
      }*/

    
    }
    catch(err) {
      console.error(err);
      return err;
    }        
  }

  /*
  const compound_port = async (words) => {  
    
    try {    
      setLoading(prevLoading=>(prevLoading+5))
      let res = await axios.post(nambot01_url + '/compound/port', { 'data' : words });                      
      let { data } = res.data;


      let dictData = data.map((result, i) => {
        return {
          label : result,
          click : false
        };
      });      
      
      setChipData((prevData) => {
        let concatData = prevData.concat(dictData);
        concatData.sort((a,b)=>{
          if (a.label.length>b.label.length) return 1;
          if (b.label.length>a.label.length) return -1;
          return 0;
        })
        return concatData;
      })


      setLoading((prevLoading)=>{
        let newLoading = prevLoading + 20
        if(newLoading >= 100){
          setDisabled(false)
        }
        return newLoading;
      })
      console.log(data);  
      return data;
    }
    catch(err) {
      console.error(err);
      return err;
    }
  }  
  */

  const compound_second = async (words) => {      
    try {
      setLoading(prevLoading=>(prevLoading+5))
      let res = await axios.post(namebot02_url + '/compound/second', { 'data' : words });
      let { data } = res.data;


      let dictData = data.map((result, i) => {
        return {
          label : result,
          click : false
        };
      });      
      
      setChipData((prevData) => {
        let concatData = prevData.concat(dictData);
        concatData.sort((a,b)=>{
          if (a.label.length>b.label.length) return 1;
          if (b.label.length>a.label.length) return -1;
          return 0;
        })
        return concatData;
      })

      setLoading((prevLoading)=>{
        let newLoading = prevLoading + 60
        if(newLoading  >= 100){
          setDisabled(false)
        }
        return newLoading;
      })
      console.log(data);   

      return data;
    }
    catch(err) {
      console.error(err);
      return err;

    }    
  }  

  function _requestPost(words){

    if( words.length === 1){

      setLoading(0)
      setDisabled(true)
      setChipData([])

      Promise.all([single_rnn(words), single_pattern(words), _store_keywords(words)])
      .then((result)=>{
        if(result[0] instanceof Error || result[1] instanceof Error){

          if('message' in result[0]){
            result[0] = result[0].message
          }
          if('message' in result[1]){
            result[1] = result[1].message
          }           

          console.log('Error')
          setLoading((prevLoading)=>{
            setDisabled(false)          
            return 100
          })  

        } 

        let results = {
          'rnn': result[0], 
          'pattern': result[1],
        }
       _store_results(result[2], results)

      })
      .catch((err)=>{
        console.error(err)
      })
      

      
      
    }
    else if( words.length === 2){
      setChipData([])
      setLoading(0)
      setDisabled(true)

      
      //Promise.all([compound_second(words), compound_pattern(words), compound_port(words), _store_keywords(words)])
      Promise.all([compound_second(words), compound_pattern(words), _store_keywords(words)])
      .then((result)=>{
        
        if(result[0] instanceof Error || result[1] instanceof Error || result[2] instanceof Error){

          if('message' in result[0]){
            result[0] = result[0].message
          }
          if('message' in result[1]){
            result[1] = result[1].message
          }           
          /*if('message' in result[2]){
            result[2] = result[2].message
          }*/          

          console.log('Error')
          setLoading((prevLoading)=>{
            setDisabled(false)          
            return 100
          })  

        }

        let results = {
          'second': result[0],
          'pattern': result[1],
          //'port': result[2],
        };  
        _store_results(result[2], results)

      })
      .catch((err)=>{
        console.error(err)
      })      

    }
    else {
      console.log(errorPlaceholder)
      setKeyWords('')
      setPlacehoderText(errorPlaceholder)
    }

  }


  function _handleOnClick(e){
    console.log(keywords)
    if (keywords.length > 0 && check_engnum.test(keywords)){

      
      let value = keywords.trim()
      let words = value.split(' ')
      console.log(words)
      _requestPost(words)  
    }
    else {
      setKeyWords('')
      setPlacehoderText(errorPlaceholder)
    }
  }
  function _handleKeyDown(e){
    
    //console.log(e)
    if (e.key === 'Enter') {
      if (keywords.length > 0 && check_engnum.test(keywords)){
        console.log('do validate');
        let value = e.target.value.trim()
        let words = value.split(' ')
        console.log(words)
        _requestPost(words)      
      }
      else {
        setKeyWords('')
        setPlacehoderText(errorPlaceholder)
      }
    }
  }

  function callKakao(e){
    //외부 함수 호출을 위해 window 사용.
    let stateObj = {foo:'bar'}
    //window.history.pushState(stateObj, "test", "?keys=brand")
    let checkedData = chipData.filter(result=>result.click===true);
    if (checkedData.length > 0) {
      let query = checkedData.map(data=>data.label).join(',');
      console.log(checkedData)
      window.history.pushState(stateObj, "test", "?checked=" + query)
  
    }
    window.chatChannel()
    
  }  

  const handelChipClick = chipData => () => {
    
    console.log(chipData)
    setChipData(chips => chips.map(data => {
      if(data.label === chipData.label) data.click = !data.click 
      return data
    }))

  }

  const _store_keywords = async (keywords) => {

    return await db.collection("tracking").add({
      keywords: keywords.join(' '),
      created : serverTimeStamp,
      })
      .then(function(docRef) {
          console.log("Document written with ID: ", docRef.id);
          return docRef.id;
      })
      .catch(function(error) {
          console.error("Error adding document: ", error);
      });
    
  }

  const _store_results = async (doc_id, results) => {

    let docRef = db.collection("tracking").doc(doc_id);

    return await docRef.update({
      results : results,
      updated : serverTimeStamp,
    })
    .then(function() {
      console.log("Document successfully updated!");
    })
    .catch(function(error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });
  }  

  return (
    <div className="App">
      <CssBaseline />
  
      <Container maxWidth="sm" style={{ marginTop:'10vh'}}> 
      <Typography component="div" style={{ height: '80vh' }} >
      <Box className={classes.main}>
      <Typography variant="h4" component="p">
      <span role="img" aria-label="sheep">&#129302;</span>
      </Typography>
      <Typography variant="h6" component="p">
            인공지능 <strong>BRAND<font color='red'>AI</font>ZER</strong>로
            <br />
            당신의 브랜드명을 만들어보세요.
      </Typography>
      </Box>


      <Paper className={classes.root}>
        <InputBase    
          autoFocus={true}
          value={keywords}
          onChange={e=>setKeyWords(e.target.value)}
          disabled={disabled}
          className={classes.input}
          placeholder={placeholderText}
          inputProps={{ 'aria-label': '브랜드명 생성을 위해 영어 단어를 입력하세요.(두단어 이내)' }}
          onKeyDown={_handleKeyDown}
        />
        <IconButton className={classes.iconButton} aria-label="search" onClick={_handleOnClick}>
          <SearchIcon />
        </IconButton>

      </Paper>
      
      {(loading > 0 || chipData.length > 0) && <ThemeProvider theme={theme}>
      <Card className={classes.card}>
      <CardContent>
        <Typography className={classes.title} color="textSecondary" gutterBottom>
          { loading > 0 && ('제안된 이름') }
        </Typography>

        
        {chipData.map(
          (result, i) => {
            return (
              
              <Chip 
                key={i}
                label={result.label}
                className={classes.chip}
                onClick={handelChipClick(result)}
                color={result.click?'primary':'secondary'}
                variant={result.click?'default':'outlined'}

              />
              
            )
          }
        )}
      
        {
          (loading > 0 && loading < 100 ) ? (
            
            <div className={classes.progress} >
                  <LinearProgress variant="buffer" value={loading} valueBuffer={loading+20} />
            </div>
            

          ) : (
            (loading >= 100) ? 
            (
            <Typography variant="body1" component="p">
              <br/>
              맘에 드는 상표명을 찾으셨나요?<br/>
              <br/>
              맘에 드는 상표명을 클릭해서 <br/>
              지금 바로 등록 가능여부를 상담해보세요<br/>
              <br/>            
              <input type='image' alt='카카오톡 상담' onClick={callKakao} src="https://developers.kakao.com/assets/img/about/logos/channel/consult_small_yellow_pc.png"/>
            </Typography>              
            ):(
              <span></span>
            )
  
          )
        }
      </CardContent>
    </Card>
    </ThemeProvider>}
      </Typography>
      </Container>
    </div>
  );
}

export default App;
